import api from './api'

export const playbackService = {
  /**
   * Fetch pre-calculated per-bar indicator state for playback mode.
   *
   * @param {Object} params
   * @param {string} params.symbol - Trading symbol, e.g. BTC/USDT
   * @param {string} params.timeframe - One of 15m, 1h, 4h
   * @param {number} params.from_time - Start timestamp (seconds)
   * @param {number} params.to_time - End timestamp (seconds)
   * @param {string[]} [params.include] - Indicator groups to include
   */
  getPlaybackData: (params) => api.post('/charting/playback', params),
}
